export default __webpack_public_path__ + "static/newsletter-2-2-2e25d2c939f21c83062d6f66938dfda9.png";